import $ from "jquery";

let listEl = $(".advisor-verify");

let filter = {
    search: '',
};

$(function () {
    listEl.each(function () {
        advisorSearch($(this));
    });
});

const advisorSearch = (listEl) => {  
    bindAdvisorSearchButtons(listEl, filter);
};

const reRenderList = async (element, filter, append = false) => {  
    let data = await getAdvisors(filter);  
    
    element.find("#advisor-verify").html('');
    element.find("#advisor-verify").html(data.html);
    
};

const bindAdvisorSearchButtons = (element, filter) => {
    element.on("click", ".advisor-verify__buttonSearch", function () {
      filter.search = element.find("#advisor-verify__form_input_text").val();
      reRenderList(element, filter);
    });

    element.on("keypress", "#advisor-verify__form_input_text", function (event) {
      if (event.key === 'Enter') {
        filter.search = element.find("#advisor-verify__form_input_text").val();
        reRenderList(element, filter);
      }
    });
  
    element.on("click", ".advisor-verify__buttonReset", function () {
      filter.search = "";
    
      element.find("#advisor-verify__form_input_text").val("");
      element.find("#advisor-verify").html('');
    });
}

const getAdvisors = async (filter) => {
    try {
      const response = await fetch(
        SITE_PARAMS.site_url + `/wp-json/nzu/v1/advisor-verify/html`,
        {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
          }),
          body: JSON.stringify(filter),
        }
      );
      const result = await response.json();
      return result;
    } catch (e) {
      console.log(e);
      return null;
    }
};

